import IngredientWellInfo, {
  Props as IIngredientWellInfoProps,
} from 'components/commandpanel/IngredientInfo/IngredientWellInfo';
import React from 'react';

interface Props {
  ingredientWellProps: IIngredientWellInfoProps;
}
const WellInfo = (props: Props) => {
  const { ingredientWellProps } = props;
  return <IngredientWellInfo {...ingredientWellProps} />;
};

export default WellInfo;
